<template>
  <div>
    <ListSearch ref="listSearch" :formSearch="formSearch">
      <template #buttons>
        <el-button type="primary" @click="addItem">新建客户</el-button>
      </template>
      <template #forms>
        <el-form-item label="名称">
          <el-input
            v-model="formSearch.name"
            placeholder="请输入名称"
            clearable
          ></el-input>
        </el-form-item>
        <div class="buttons">
          <el-button type="primary" @click="$refs.listSearch.search()">查询</el-button>
          <el-button @click="$refs.listSearch.reset()">重置</el-button>
        </div>
      </template>
      <template #list="{ tableData, loading }">
        <el-table :data="tableData" v-loading="loading" border>
          <el-table-column label="名称" align="center" width="250">
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  align-items: center;
                  padding: 0 30px 0 50px;
                "
              >
                <el-image
                  style="width: 50px; height: 50px; border-radius: 50%"
                  :src="'/staticfile/' + scope.row.logoImage.urlMinimal"
                  :preview-src-list="['/staticfile/' + scope.row.logoImage.src]"
                  fit="cover"
                ></el-image>
                <span style="margin-left: 10px; flex: 1; text-align: left">{{
                  scope.row.name
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            v-for="(item, index) in tableKey"
            :key="index"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">{{
              item.myFilter
                ? item.myFilter(scope.row[item.prop])
                : scope.row[item.prop]
            }}</template>
          </el-table-column>
          <el-table-column align="center" label="数据接口" width="250">
            <template slot-scope="scope">
              <div
                class="my-button"
                @click="openapi(scope.row, false)"
                v-if="scope.row.openapi"
                type="red"
              >
                <i class="iconfont icontingyong"></i>已开放
              </div>
              <div
                class="my-button"
                v-if="scope.row.openapi"
                @click="showToken(scope.row)"
              >
                <i class="iconfont el-icon-s-opportunity"></i>Token
              </div>
              <div class="my-button" @click="openapi(scope.row, true)" v-else>
                <i class="iconfont iconqiyong"></i>未开放
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="250">
            <template slot-scope="scope">
              <div class="my-button" @click="editItem(scope.row)">
                <i class="iconfont iconedit"></i>修改
              </div>
              <div class="my-button" @click="deleteItem(scope.row)">
                <i class="iconfont icontrash"></i>删除
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </ListSearch>
    <EditDialog
      :dialogShow.sync="editDialogShow"
      :formData="editDialogData"
      :typeList="typeList"
      :companyList="companyList"
      @updateData="$refs.listSearch.updateData()"
    ></EditDialog>
    <el-dialog title="Token" :visible.sync="openapiVisible" width="30%">
      <div style="color: #e92634">请复制token并发送给客户</div>
      <div>{{ openapiToken }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="openapiVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListSearch from "@/components/ListSearch/ListSearch";
import EditDialog from "./components/EditDialog";
export default {
  data() {
    return {
      editDialogShow: false, // 编辑弹窗是否显示
      editDialogData: null, // 编辑弹窗表单数据
      openapiVisible: false,
      openapiToken: null,
      formSearch: {
        name: "", // 名称搜索
      },
      tableKey: [
        {
          prop: "shortName",
          label: "简称",
        },
        {
          prop: "address",
          label: "地址",
        },
        {
          prop: "contacts",
          label: "联系人",
        },
        {
          prop: "mobile",
          label: "联系电话",
        },
      ],
      typeList: [], // 公司类型列表
      companyList: [], // 养护单位列表
    };
  },
  components: {
    ListSearch,
    EditDialog,
  },
  created() {
    this.getTypeList();
    this.getCompanyList();
  },
  mounted() {
    this.$refs.listSearch.search();
  },
  methods: {
    getList(page, size) {
      return this.$http.get("/company/page/v1", {
        ...this.formSearch,
        page,
        size,
      });
    },
    // 获取公司类型列表
    getTypeList() {
      this.$http.get("/company/type-list/v1").then((res) => {
        this.typeList = res;
      });
    },
    // 获取养护单位列表
    getCompanyList() {
      this.$http
        .get("/company/agent-all/v1", {
          page: 0,
          size: 999,
        })
        .then((res) => {
          this.companyList = res;
        });
    },
    // 新建
    addItem() {
      this.editDialogData = null;
      this.editDialogShow = true;
    },
    // 编辑
    editItem(item) {
      this.editDialogData = item;
      if (item.logoImage) {
        this.editDialogData.logo = [
          {
            uid: item.logoImage.id,
            id: item.logoImage.id,
            url: "/staticfile/" + item.logoImage.urlMedium,
          },
        ];
      } else {
        this.editDialogData.logo = [];
      }
      this.editDialogShow = true;
    },
    // 删除
    deleteItem(item) {
      this.$confirm("确认删除吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.$http
          .delete(
            "/company/delete/v1",
            {
              companyId: item.id,
            },
            "提交中……",
            "删除成功"
          )
          .then(() => {
            this.$refs.listSearch.updateData();
          });
      });
    },
    // 开放、关闭数据接口
    openapi(item, enabled) {
      var url = `/company/api/v1?companyId=${item.id}`;
      if (enabled) {
        this.$http.post(url, {}, "提交中……", "开放成功").then((res) => {
          this.$refs.listSearch.updateData();
          this.openapiToken = res;
          this.openapiVisible = true;
        });
      } else {
        this.$http.delete(url, {}, "提交中……", "成功关闭").then(() => {
          this.$refs.listSearch.updateData();
        });
      }
    },
    showToken(item) {
      var url = `/company/api/v1?companyId=${item.id}`;
      this.$http.get(url, {}).then((res) => {
        this.openapiToken = res;
        this.openapiVisible = true;
      });
    },
  },
};
</script>